import { useState } from 'react';

import { useWindowWidth } from './useWindowWidth';

type TUseTwoCollapsableCardsStateReturn<T> = {
  data: T | null;
  isFirstCardCollapsed: boolean;
  isSecondCardCollapsed: boolean;
  isOpen: boolean;
  handleFirstCardCollapse: () => void;
  handleSecondCardCollapse: () => void;
  handleOpenSecondCard: (dossierTemplate: T) => void;
  handleAccordionOpen: () => void;
  setData: React.Dispatch<React.SetStateAction<T | null>>;
  handleRemoveItemDetail: () => void;
};

export function useTwoCollapsableCardsState<T>(
  showFirstDetail?: boolean
): TUseTwoCollapsableCardsStateReturn<T> {
  const [data, setData] = useState<T | null>(null);
  const [isOpen, setOpen] = useState<boolean>(!showFirstDetail);
  const [isFirstCardCollapsed, setIsFirstCardCollapsed] = useState(!!showFirstDetail);
  const [isSecondCardCollapsed, setIsSecondCardCollapsed] = useState(false);

  const { width } = useWindowWidth();

  const handleFirstCardCollapse = () => {
    setIsFirstCardCollapsed(!isFirstCardCollapsed);
    if (!isFirstCardCollapsed && isSecondCardCollapsed) {
      setIsSecondCardCollapsed(false);
    }
  };

  const handleSecondCardCollapse = () => {
    setIsSecondCardCollapsed(!isSecondCardCollapsed);
    if (!isSecondCardCollapsed && isFirstCardCollapsed) {
      setIsFirstCardCollapsed(false);
    }
  };

  const handleOpenSecondCard = (data: T) => {
    setData(data);
    setIsSecondCardCollapsed(false);

    if (width < 994) {
      setOpen(!isOpen);
    }
  };

  const handleRemoveItemDetail = () => {
    setData(null);
    setIsSecondCardCollapsed(true);

    if (width < 994) {
      setOpen(!isOpen);
    }
  };

  const handleAccordionOpen = () => {
    setOpen(!isOpen);
  };

  return {
    data,
    isFirstCardCollapsed,
    isSecondCardCollapsed,
    isOpen,
    handleFirstCardCollapse,
    handleSecondCardCollapse,
    handleOpenSecondCard,
    handleAccordionOpen,
    setData,
    handleRemoveItemDetail,
  };
}
